import { StoreChannel } from 'common/types/entities/store'
import { convertPrivacyChannel, fetchSSChannel, isChannelWithHighRatingReview } from 'common/services/channel'
import { StateKey } from 'common/utils/flipState'
import { createCacheParam, isCacheHit } from 'common/utils/reduxCache'
import { PageType } from 'common/types'
import { SSChannel } from 'common/types/entities/api/channel'
import { includeStoreInfoWithHighRatingReview } from 'common/constants'

export const initialState: StoreChannel = {
  channel: null,
  cacheParam: null,
  hasHighRatingReview: false,
}

const FETCH = '/store/FETCH'

export const fetchStore = (curState: StateKey, id: string, pageType?: PageType) => async (dispatch, getState) => {
  const cacheParam = createCacheParam(FETCH, 'fetchStore', { curState, id })
  if (isCacheHit(getState().store[curState], cacheParam)) {
    return
  }

  const [channelResult, hasHighRatingReview] = await Promise.all([
    fetchSSChannel(id),
    includeStoreInfoWithHighRatingReview(getState().subVerticalByPathname) && isChannelWithHighRatingReview(id),
  ])

  const store = channelResult ? channelResult.channel : null
  const convertedChannel = convertPrivacyChannel(store, pageType)
  dispatch({
    curState,
    cacheParam,
    hasHighRatingReview,
    channel: convertedChannel,
    type: FETCH,
  })
}

export const fetchStoreByProduct = (curState: StateKey, channel: SSChannel) => async dispatch => {
  dispatch({
    curState,
    channel,
    cacheParam: null,
    type: FETCH,
  })
}

const storeReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH:
      return {
        cacheParam: action.cacheParam,
        channel: action.channel,
        hasHighRatingReview: action.hasHighRatingReview,
      }
    default:
      return state
  }
}

export default storeReducer
